var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"wrapper-filter",attrs:{"id":"wrapper-filter"}},[_c('loading-panel'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }